module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = external "jQuery"
// module chunks = core site__ale001 azure__ale001 vendor